import { GET_DATA_DASHBOARD, GET_DATA_DASHBOARD2, GET_DATA_DASHBOARD2_SUCCEEDED, GET_DATA_DASHBOARD3, GET_DATA_DASHBOARD3_SUCCEEDED, GET_DATA_DASHBOARD4, GET_DATA_DASHBOARD4_SUCCEEDED, GET_DATA_DASHBOARD5, GET_DATA_DASHBOARD5_SUCCEEDED, GET_DATA_DASHBOARD6, GET_DATA_DASHBOARD6_SUCCEEDED, GET_DATA_DASHBOARD_SUCCEEDED, GET_DATA_PLAN_DASHBOARD, GET_DATA_PLAN_DASHBOARD_SUCCEEDED, GET_DATA_PLAN_NEXTWEEK_DASHBOARD, GET_DATA_PLAN_NEXTWEEK_DASHBOARD_SUCCEEDED, GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD, GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD_SUCCEEDED, ISRESULT, REQUERT_DATA_DASHBOARD_FAILED, REQUERT_DATA_PLAN_DASHBOARD_FAILED } from "./actionTypes"

export const IsResultAction = (isResult) => {
    return {
        type: ISRESULT,
        isResult: isResult
    }
}

export const GetDataDashboardAction = (DataDashboard) =>{
    return{
        type: GET_DATA_DASHBOARD,
        DataDashboard: DataDashboard
    }
}

export const GetDataDashboardSuccessAction = (DataDashboard) =>{
    return{
        type: GET_DATA_DASHBOARD_SUCCEEDED,
        DataDashboard: DataDashboard
    }
}
export const GetDataDashboard2Action = (DataDashboard2) =>{
    return{
        type: GET_DATA_DASHBOARD2,
        DataDashboard2: DataDashboard2
    }
}

export const GetDataDashboardSuccess2Action = (DataDashboard2) =>{
    return{
        type: GET_DATA_DASHBOARD2_SUCCEEDED,
        DataDashboard2: DataDashboard2
    }
}
export const GetDataDashboard3Action = (DataDashboard3) =>{
    return{
        type: GET_DATA_DASHBOARD3,
        DataDashboard3: DataDashboard3
    }
}

export const GetDataDashboardSuccess3Action = (DataDashboard3) =>{
    return{
        type: GET_DATA_DASHBOARD3_SUCCEEDED,
        DataDashboard3: DataDashboard3
    }
}
export const GetDataDashboard4Action = (DataDashboard4) =>{
    return{
        type: GET_DATA_DASHBOARD4,
        DataDashboard4: DataDashboard4
    }
}

export const GetDataDashboardSuccess4Action = (DataDashboard4) =>{
    return{
        type: GET_DATA_DASHBOARD4_SUCCEEDED,
        DataDashboard4: DataDashboard4
    }
}
export const GetDataDashboard5Action = (DataDashboard5) =>{
    return{
        type: GET_DATA_DASHBOARD5,
        DataDashboard5: DataDashboard5
    }
}

export const GetDataDashboardSuccess5Action = (DataDashboard5) =>{
    return{
        type: GET_DATA_DASHBOARD5_SUCCEEDED,
        DataDashboard5: DataDashboard5
    }
}
export const GetDataDashboard6Action = (DataDashboard6) =>{
    return{
        type: GET_DATA_DASHBOARD6,
        DataDashboard6: DataDashboard6
    }
}

export const GetDataDashboardSuccess6Action = (DataDashboard6) =>{
    return{
        type: GET_DATA_DASHBOARD6_SUCCEEDED,
        DataDashboard6: DataDashboard6
    }
}
export const RequertDataDashboardFailedAction = (Err) =>{
    return{
        type: REQUERT_DATA_DASHBOARD_FAILED,
        err: Err
    }
}
//Get data Plan dashboard
export const GetDataPlanDashboardAction = () =>{
    return {
        type: GET_DATA_PLAN_DASHBOARD
    }
}
export const GetDataPlanDashboarSuccessAction = (DataPlan) =>{
    return {
        type: GET_DATA_PLAN_DASHBOARD_SUCCEEDED,
        DataPlan: DataPlan
    }
}
export const RequertDataPlanDashboardFailedAction = (Err) =>{
    return{
        type: REQUERT_DATA_PLAN_DASHBOARD_FAILED,
        err: Err
    }
}
export const GetDataPlanNextWeekDashboardAction = (DataNextWeek) =>{
    return {
        type: GET_DATA_PLAN_NEXTWEEK_DASHBOARD,
        DataNextWeek: DataNextWeek
    }
}
export const GetDataPlanNextWeekDashboarSuccessAction = (DataNextWeek) =>{
    return {
        type: GET_DATA_PLAN_NEXTWEEK_DASHBOARD_SUCCEEDED,
        DataNextWeek: DataNextWeek
    }
}
export const GetDataPlanTimeExtendtionDashboardAction = (DataTimeExtend) =>{
    return {
        type: GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD,
        DataTimeExtend: DataTimeExtend
    }
}
export const GetDataPlanTimeExtendtionDashboarSuccessAction = (DataTimeExtend) =>{
    return {
        type: GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD_SUCCEEDED,
        DataTimeExtend: DataTimeExtend
    }
}